import { useReportStore } from '@store';
import { useOwnProfileQuery } from '@common/cache';
import { useEffect } from 'react';

export const usePreviewWrapper = () => {
  const { data: userProfile } = useOwnProfileQuery();
  const { report, setHideSaveOptions, setIsOwner } = useReportStore();

  useEffect(() => {
    if (userProfile?.id) {
      setHideSaveOptions(
        userProfile?.id !== report?.created_by?.id &&
          !report?.allow_others_to_edit,
      );
      setIsOwner(userProfile?.id === report?.created_by?.id);
    }
  }, [userProfile, report]);

  return { report };
};
